const Env = require('../env.json');

export const ENV = process.env.NODE_ENV;
export const { ENV_APP, BASE_URL, APP_BASE_URL } = Env[process.env.NODE_ENV];

export const { BUCKET_ACCESS_ID, BUCKET_SECRET_ACESS_KEY, BASE_URL_API, API_GOOGLE_KEY } = Env[
  process.env.NODE_ENV
];
